import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLicense } from "../contexts/LicenseContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const { hasActiveLicense, isBreweryMember, breweryId } = useLicense();

  if (loading) {
    return null; // or a loading spinner
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Brewery members get license from their brewery admin - skip individual license check
  if (isBreweryMember && breweryId) {
    return <>{children}</>;
  }

  if (hasActiveLicense === false) {
    return <Navigate to="/settings" replace />;
  }

  return <>{children}</>;
}
